import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
var SpanLabelComponent = /** @class */ (function () {
    function SpanLabelComponent() {
    }
    SpanLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'item-spanlabel',
                    template: '<span class="{{ cls }}">{{ txt }}</span>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    SpanLabelComponent.propDecorators = {
        cls: [{ type: Input }],
        txt: [{ type: Input }]
    };
    return SpanLabelComponent;
}());
export { SpanLabelComponent };
//# sourceMappingURL=spanlabel.component.js.map